
import React, { useEffect, useState } from "react";

import PathContext from "./context/path";
import StatesContext from "./context/states";
import Main from './pages/Main';
import Background from './components/Background';
import Header from './components/Header';
import Footer from './components/Footer/Footer';

const App = () => {

  const basename = '.';

  const [isMobile, setMobile] = useState(false);
  const [data, setData] = useState([]);
  const [dataResults, setDataResults] = useState([]);
  const [stage, setStage] = useState(0);
  const [page, setPage] = useState(0);
  const [fullWeight, setFullWeight] = useState([1, 1, 1, 1, 1]);
  const [weight, setWeight] = useState([1, 1,1, 1, 1]);
  const updateWeight = (array) => setWeight(array);
  const updateStage = (number) => {
    if (stage >= data.length - 1) {
      setPage(prev => prev + 1)
    }
    setStage(number)
  };
  const updatePage = (number) => setPage(number);
  const restartHanler = ()=>{
    setStage(0);
    setPage(1);
    setTimeout(() => {
      setWeight([1, 1,1, 1, 1]);
    }, 300);
  }
  useEffect(() => {
    window.scrollTo(0, 0);
    document.querySelector('body').style.opacity = 1;

    fetch(`${basename}/data/data.json?ver=${Math.floor((Math.random() * 0xfffff * 1000000)).toString(16)}`)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        setData(data.questions);
        countFullWeight(data.questions);
        setDataResults(data.results);
      });

    const combineArrays = (a, b) => {
      let length = Math.min(a.length, b.length);
      let resultingArray = [];
      for (let i = 0; i < length; i++) {
        if (isNaN(resultingArray[i] = +a[i] + +b[i])) return false;
      }
      return resultingArray;
    }
    const countFullWeight = (data) => {
      let array = [0, 0, 0, 0, 0];
      data.forEach((element) => {
        const weight = element.weight;
        const result = weight[0].map((_, index) =>
          Math.max(...weight.map(arr => arr[index]))
        );
        array = combineArrays(array, result);
      });
      setFullWeight(array);

    }
  }, []);


  useEffect(() => {
    const handleMobile = () => {
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
      if (window.outerWidth < 768 && !isMobile) {
        setMobile(true);
      }
      if (window.outerWidth >= 768 && isMobile) {
        setMobile(false);
        document.documentElement.style.setProperty('--vh', ``);
      }
    }
    handleMobile();
    window.addEventListener('resize', handleMobile);
    return () => {
      document.documentElement.style.setProperty('--vh', ``);
      window.removeEventListener('resize', handleMobile);
    }
  }, [isMobile]);

  return (
    <StatesContext.Provider value={{ isMobile: isMobile, data: data, updateStage: updateStage, stage: stage, updateWeight: updateWeight, weight: weight, updatePage: updatePage, page: page, fullWeight: fullWeight, dataResults: dataResults, restartHanler: restartHanler }}>
      <PathContext.Provider value={basename}>
        <div className={'wrap'}>
          {/* <Support /> */}
          <Header />
          <Main />
          <Footer />
          <Background />
        </div>
      </PathContext.Provider>
    </StatesContext.Provider>
  );

}


export default App;
